import React, { useState } from 'react';
import LoginForm from '../../components/loginForm/LoginForm';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosClient from '../../api/axiosClient';
import LoadingOverlay from "../../components/loadingOverlay/LoadingOverlay";

const Login = () => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { doLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Get the redirectTo query param (if any)
  const queryParams = new URLSearchParams(location.search);
  // Redirect to the page the user tried to access or to a default page after login
  const redirectTo = location.state?.from || queryParams.get('redirectTo') || '/'; // Default to '/' if no previous route

  const handleLogin = async ({
    email,
    password
  }) => {
    setIsLoading(true);
    await axiosClient.post('auth/login', {
      email,
      password
    })
    .then((response) => {
      doLogin(response.data);
      navigate(redirectTo);
    })
    .catch((error) => {
      setError(error.message);
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <LoginForm
        onSubmit={handleLogin}
        error={error}
      />
    </>
  );
}

export default Login;
